import { Controller } from '@hotwired/stimulus'
import { createApp, h } from 'vue'
import { createPinia } from 'pinia'
import FaIcon from '@/apps/shared/components/fa-icon.vue'
import VueLadda from '@/apps/shared/components/vue-ladda.vue'
import App from '@/apps/fast-contact/App.vue'
import { useMainStore } from '@/apps/fast-contact/stores/main'

const pinia = createPinia()

const store = useMainStore(pinia)

export default class extends Controller {
  static values = {
    currentUserId: String,
    currentUserSlug: String,
    currentUserConfirmed: Boolean,
    designerId: String,
    designerName: String,
    createdConversationId: String,
    quotaExceeded: Boolean
  }

  connect() {
    store.resetAll()

    const appWrapper = document.createElement('div')
    document.querySelector('body').appendChild(appWrapper)

    const self = this

    window.fastContactApp = createApp({
      data() {
        return {
          currentUserId: null,
          currentUserSlug: null,
          currentUserConfirmed: null,
          designerId: null,
          designerName: null,
          createdConversationId: null,
          quotaExceeded: null
        }
      },
      beforeMount() {
        this.currentUserId = self.currentUserIdValue
        this.currentUserSlug = self.currentUserSlugValue
        this.currentUserConfirmed = self.currentUserConfirmedValue
        this.designerId = self.designerIdValue
        this.designerName = self.designerNameValue
        this.createdConversationId = self.createdConversationIdValue
        this.quotaExceeded = self.quotaExceededValue
      },
      async mounted() {
        // "hack" to open the fast contact modal when redirected after confirmation
        if (this.createdConversationId) self.element.click()
      },
      render() {
        return h(App)
      }
    })
      .use(pinia)
      .component('VueLadda', VueLadda)
      .component('FaIcon', FaIcon)

    window.fastContactApp.mount(appWrapper)
  }

  disconnect() {
    window.fastContactApp.unmount()
  }
}
